<template>
  <div v-if="objDTO !== null">
    <div class="container">
      <div class="white-frame" v-if="stage == 1">
        <div class="title-text mb-3"><b>Dados do Sinistro</b></div>
        <div class="row g-3 pb-3">
          <div class="col-md-6">
            <label class="form-label" for="sinistroData">Data Sinistro</label>
            <Calendar
              id="sinistroData"
              v-model="objDTO.Sinistro.SinistroData"
              dateFormat="dd/mm/yy"
              disabled
              class="form-control p-0"
            />
          </div>
          <div
            class="col-md-6"
            :class="{
              'field-required': $v.objDTO.Sinistro.SinistroData.$invalid,
            }"
          >
            <label class="form-label" for="sinistroHora">Hora Sinistro</label>
            <Calendar
              id="sinistroHora"
              v-model="objDTO.Sinistro.SinistroData"
              dateFormat="dd/mm/yy"
              :timeOnly="true"
              hourFormat="24"
              :showSeconds="false"
              :manualInput="false"
              class="form-control p-0"
            />
          </div>
          <loading-state v-if="loading.coverages" />
        </div>

        <div v-if="!loading.coverages" class="row g-3 pb-3">
          <div
            class="col-md-6"
            v-if="riskUnits.length > 1"
            :class="{
              'field-required':
                $v.objDTO.Apolice.UnidadeDeRiscoExternalId.$invalid,
            }"
          >
            <label class="form-label" for="riskUnit">Unidade de Risco</label>
            <Dropdown
              id="riskUnit"
              placeholder="Selecione"
              v-model="objDTO.Apolice.UnidadeDeRiscoExternalId"
              :options="riskUnits"
              optionLabel="Description"
              optionValue="RiskUnitId"
              class="form-control p-0"
            />
          </div>
          <div
            class="col-md-6"
            v-if="insuranceObjects.length > 1"
            :class="{
              'field-required':
                $v.objDTO.Apolice.ObjectoSeguradoExternalId.$invalid,
            }"
          >
            <label class="form-label" for="insuranceObject"
              >Objeto Segurado</label
            >
            <Dropdown
              id="insuranceObject"
              placeholder="Selecione"
              v-model="objDTO.Apolice.ObjectoSeguradoExternalId"
              :options="insuranceObjects"
              optionLabel="Description"
              optionValue="InsuranceObjectId"
              class="form-control p-0"
            />
          </div>

          <div
            class="col-md-6"
            :class="{
              'field-required': $v.objDTO.Apolice.ApoliceCoberturaId.$invalid,
            }"
          >
            <label class="form-label" for="coverages">Cobertura</label>
            <Dropdown
              id="coverages"
              placeholder="Selecione"
              @change="changeCoverage"
              v-model="objDTO.Apolice.ApoliceCoberturaId"
              :options="coverages"
              optionLabel="Description"
              optionValue="GisCoverageId"
              class="form-control p-0"
            />
          </div>
          <div
            class="col-md-6"
            v-if="coverages.length > 1"
            :class="{
              'field-required': $v.objDTO.Sinistro.SinistroEventoId.$invalid,
            }"
          >
            <label class="form-label" for="evento">Evento</label>
            <Dropdown
              id="evento"
              placeholder="Selecione"
              v-model="objDTO.Sinistro.SinistroEventoId"
              :options="events"
              optionLabel="Description"
              optionValue="Id"
              class="form-control p-0"
            />
          </div>

          <div
            class="col-md-6"
            v-if="coverages.length > 1"
            :class="{
              'field-required':
                $v.objDTO.Sinistro.BoletimOcorrencia.BoletimOcorrenciaOpcaoId
                  .$invalid,
            }"
          >
            <label class="form-label" for="sinistroHora">BO</label>
            <Dropdown
              id="boletimOcorrencia"
              placeholder="Selecione"
              v-model="
                objDTO.Sinistro.BoletimOcorrencia.BoletimOcorrenciaOpcaoId
              "
              :options="optionYN"
              optionLabel="Description"
              optionValue="Id"
              class="form-control p-0"
            />
          </div>

          <div
            class="col-md-12"
            v-if="coverages.length > 1"
            :class="{
              'field-required': $v.objDTO.Sinistro.SinistroDescricao.$invalid,
            }"
          >
            <label class="form-label" for="sinistroDesc"
              >Descrição da Ocorrência</label
            >
            <Textarea
              id="sinistroDesc"
              v-model="objDTO.Sinistro.SinistroDescricao"
              :autoResize="true"
              rows="5"
              cols="30"
              class="form-control"
            />
          </div>
        </div>

        <BensSinistrados
          v-if="!loading.coverages"
          ref="bensSinistrados"
          :gdmTipos="gdmTipos"
          :isLoadingGdmTipos="loading.gdmTipos"
          :isReadonlyStage="false"
          :processoGDM="objDTO.ProcessoGDM"
          :maxDate="maxDate"
          @update:listaBensSubtraidos="updateListaBensSubtraidos"
          @update:estimativaPrejuizo="(val) => (estimativaPrejuizo = val)"
        />

        <div
          class="col-12 Aligner aligner-right mt-4"
          v-if="!$v.objDTO.$invalid && !$v.listaBensSubtraidos.$invalid"
        >
          <button
            class="button-base-small btn-green font-small mx-1"
            @click="goToResumeBolsaProtegida()"
          >
            Finalizar
          </button>
        </div>
      </div>
    </div>

    <div v-if="stage === 2">
      <div class="container">
        <div class="white-frame">
          <div class="title-text mb-3">
            <b>Resumo das informações para acionamento de Seguro</b>
          </div>
          <div
            class="output-format d-xl-flex justify-content-xl-evenly py-xl-3"
          >
            <resume-bolsa-protegida
              :objDTO="objDTO"
              :events="events"
              :coverages="coverages"
              :gdmTipos="gdmTipos"
              :riskUnits="riskUnits"
              :insuranceObjects="insuranceObjects"
              :optionYN="optionYN"
              @back="back"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ResumeBolsaProtegida from '../components/Resume/ResumeBolsaProtegida.vue';
import LoadingState from '../components/LoadingState.vue';

import { required } from 'vuelidate/lib/validators';
import { cpfCnpjValid, dateAfterToday } from '../utils/customValidations';
import { getInfoByOperationPK } from '../utils/helpers';
import { getEvents, getOptions, getGDMTiposFiltro } from '../api/formMethods';
import { GDM_TIPO_FILTER } from '../utils/constants';
import BensSinistrados from '../components/shared/BensSinistrados.vue';

// import VueScrollTo from "vue-scrollto";

export default {
  components: {
    ResumeBolsaProtegida,
    LoadingState,
    BensSinistrados,
  },
  data() {
    return {
      stage: 1,
      maxDate: new Date(),
      objDTO: null,
      operationPK: null,
      gisRamoId: null,
      gisProdutoId: null,
      optionYN: [],
      loading: {
        coverages: false,
        gdmTipos: false,
      },
      insuranceObjects: [],
      riskUnits: [],
      coverages: [],
      events: [],
      gdmTipos: [],
      listaBensSubtraidos: [],
      estimativaPrejuizo: 0,
    };
  },
  validations() {
    return {
      listaBensSubtraidos: { required },
      objDTO: {
        Apolice: {
          ApoliceCoberturaId: { required },
          UnidadeDeRiscoExternalId: { required },
          ObjectoSeguradoExternalId: { required },
        },
        ComunicanteContacto: {
          ParentescoId: {
            required,
          },
        },
        SeguradoContacto: {
          Nome: { required },
          NrContribuinte: { required, cpfCnpjValid },
          DataNascimento: { required, dateAfterToday },
          nrID: { required },
        },
        Sinistro: {
          SinistroData: { required, dateAfterToday },
          SinistroEventoId: { required },
          SinistroDescricao: { required },
          BoletimOcorrencia: {
            BoletimOcorrenciaOpcaoId: { required },
          },
        },
      },
    };
  },
  async mounted() {
    this.objDTO = this.$store.getters.getObjDTO;
    this.optionYN = await getOptions();
    await this.tryLoadGdmTipos();
    await this.policySelected(this.objDTO.Apolice.ApoliceContrato);
  },
  beforeDestroy() {
    this.objDTO.Apolice.ApoliceNr = null;
    this.objDTO.Apolice.UnidadeDeRiscoExternalId = null;
    this.objDTO.Apolice.ObjectoSeguradoExternalId = null;
    this.objDTO.Apolice.ApoliceCoberturaId = null;
    this.objDTO.Sinistro.SinistroDescricao = null;
    this.objDTO.Sinistro.BoletimOcorrencia.BoletimOcorrenciaOpcaoId = null;
    this.objDTO.Sinistro.SinistroEventoId = null;
    // this.objDTO.Sinistro.ProcessoGDM = null;
  },
  methods: {
    updateListaBensSubtraidos(listaBensSubtraidos) {
      this.listaBensSubtraidos = listaBensSubtraidos;
    },
    async tryLoadGdmTipos() {
      try {
        this.loading.gdmTipos = true;
        this.gdmTipos = await getGDMTiposFiltro(GDM_TIPO_FILTER.BolsaProtegida);
      } catch (error) {
        console.log(error);
      } finally {
        this.loading.gdmTipos = false;
      }
    },
    vinculoSegurado(contacto) {
      if (this.objDTO.ComunicanteContacto.ParentescoId == 1) {
        this.objDTO.SeguradoContacto.Nome = contacto.nome;
        this.objDTO.SeguradoContacto.NrContribuinte = contacto.cpf;
      } else {
        this.objDTO.SeguradoContacto.Nome = null;
        this.objDTO.SeguradoContacto.NrContribuinte = null;
      }
    },
    back(newStage) {
      this.stage = newStage;
    },
    async policySelected(operationPK) {
      if (operationPK) {
        // this.operationPK = operationPK;

        window.scrollTo(0, 0);

        try {
          this.loading.coverages = true;

          const {
            riskUnit,
            riskUnits,
            insuranceObject,
            insuranceObjects,
            coverage,
            coverages,
            events,
          } = await getInfoByOperationPK(
            operationPK,
            this.objDTO.Apolice.ApoliceProdutoId,
            this.objDTO.Sinistro.SinistroRamoId
          );

          this.objDTO.Apolice.UnidadeDeRiscoExternalId = riskUnit;
          this.objDTO.Apolice.ObjectoSeguradoExternalId = insuranceObject;
          this.objDTO.Apolice.ApoliceCoberturaId = coverage;
          this.riskUnits = riskUnits;
          this.events = events;
          this.insuranceObjects = insuranceObjects;
          this.coverages = coverages;
        } catch (error) {
          console.error(error);
        } finally {
          this.loading.coverages = false;
        }
      }
    },
    async changeCoverage() {
      this.objDTO.Sinistro.SinistroEventoId = null;
      this.events = await getEvents(
        this.objDTO.Apolice.ApoliceProdutoId,
        this.objDTO.Apolice.ApoliceCoberturaId,
        this.objDTO.Sinistro.SinistroRamoId
      );
    },
    goToResumeBolsaProtegida() {
      this.objDTO.ProcessoGDM = {
        ...(this.objDTO.ProcessoGDM ?? {}),
        DescricaoGeral: 'BolsaProtegida',
        CompraValor: this.estimativaPrejuizo,
      };

      this.objDTO.ProcessoGDM.ChildrenProcessoGDMDTOs = this.listaBensSubtraidos.slice();

      this.stage = 2;
    },
  },
};
</script>

<style scoped>
.question {
  color: red;
}
</style>
